/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
import React, { FunctionComponent, ComponentClass, ReactElement } from 'react';
import { useUserData } from '../hooks/context/userUserData.hook';

export function withUserDataHOC(Component: FunctionComponent<any> | ComponentClass<any, any>): (props: any) => ReactElement {
  return (props: any) => {
    const [userData, setUserData] = useUserData();

    return <Component {...props} userData={userData} setUserData={setUserData} />;
  };
}
